/**
* GameContext.js
* 
* Created on 13-mei-2014, 16:45:14
*
* @author Ivo Swartjes for Ranj
**/

export default class GameContext {
    constructor(type, contentID, contextID) {
        this.type = type;
        this.contentID = contentID;
        this.contextID = contextID;
    }
}

GameContext.GLOBAL = "GLOBAL";
GameContext.DIALOG_STATE = "DIALOG_STATE";
